import CurrencySelectModal from './CurrencySelectModal';

export default CurrencySelectModal;
